import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  dialogPaper: {
    borderRadius: 16,
    padding: theme.spacing(1),
    maxWidth: 700,
    position: 'relative',
    overflow: 'visible',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: theme.spacing(2.5, 3, 0.5),
  },
  title: {
    fontFamily: 'Poppins, sans-serif',
    fontSize: 22,
    fontWeight: 600,
    color: '#0E1247',
  },
  closeButton: {
    color: '#0E1247',
  },
  content: {
    padding: theme.spacing(1, 3, 3),
  },
  socialRow: {
    display: 'flex',
    gap: theme.spacing(1.5),
    marginBottom: theme.spacing(3),
  },
  socialButtonWrapper: {
    flex: 1,
    width: '100%',
  },
  socialButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(1),
    border: '1px solid #CDCEDA',
    borderRadius: 8,
    padding: theme.spacing(1.2, 0),
    cursor: 'pointer',
    background: '#fff',
    transition: 'border-color 0.2s, background 0.2s',
    '&:hover': {
      borderColor: '#000A8C',
      background: '#F7F7FB',
    },
  },
  socialIcon: {
    fontSize: 20,
    color: '#0E1247',
  },
  xIcon: {
    fontSize: 16,
    fontWeight: 700,
    color: '#0E1247',
    lineHeight: 1,
  },
  socialLabel: {
    fontFamily: 'Poppins, sans-serif',
    fontSize: 14,
    fontWeight: 500,
    color: '#0E1247',
  },
  section: {
    marginBottom: theme.spacing(2.5),
  },
  label: {
    fontFamily: 'Poppins, sans-serif',
    fontSize: 14,
    fontWeight: 600,
    color: '#0E1247',
    marginBottom: theme.spacing(1),
  },
  urlRow: {
    display: 'flex',
    alignItems: 'stretch',
    gap: theme.spacing(1),
  },
  urlInput: {
    borderRadius: 8,
    fontSize: 14,
    fontFamily: 'Poppins, sans-serif',
    color: '#6B6B80',
    flex: 1,
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: '#CDCEDA',
    },
  },
  copyButton: {
    minWidth: 44,
    width: 48,
    height: 'auto',
    borderRadius: 8,
    borderColor: '#CDCEDA',
    color: '#0E1247',
    padding: 0,
    flexShrink: 0,
    '&:hover': {
      borderColor: '#000A8C',
      color: '#000A8C',
      background: '#F7F7FB',
    },
  },
  prefixBox: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1.5),
    border: '1px solid #CDCEDA',
    borderRadius: '8px 8px 8px 8px',
    background: '#F7F7FB',
    whiteSpace: 'nowrap',
    minHeight: 44,
    flexShrink: 0,
  },
  prefixText: {
    fontFamily: 'Poppins, sans-serif',
    fontSize: 13,
    color: '#9B9BB0',
  },
  slugInput: {
    borderRadius: '8px 8px 8px 8px',
    fontSize: 14,
    fontFamily: 'Poppins, sans-serif',
    flex: 1,
    minWidth: 0,
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: '#CDCEDA',
    },
  },
  slugInputExpanded: {
    borderRadius: '8px 8px 8px 8px',
    fontSize: 14,
    fontFamily: 'Poppins, sans-serif',
    flex: 1,
    minWidth: 0,
    width: '100%',
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: '#CDCEDA',
    },
  },
  langSuffixBox: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1.5),
    border: '1px solid #CDCEDA',
    borderRadius: 8,
    background: '#F7F7FB',
    whiteSpace: 'nowrap',
    minHeight: 44,
    flexShrink: 0,
  },
  langSuffixText: {
    fontFamily: 'Poppins, sans-serif',
    fontSize: 13,
    color: '#9B9BB0',
  },
  infoRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.8),
    marginTop: theme.spacing(1),
  },
  infoIcon: {
    fontSize: 18,
    color: '#9B9BB0',
  },
  infoText: {
    fontFamily: 'Poppins, sans-serif',
    fontSize: 13,
    color: '#6B6B80',
  },
  slugWarningBox: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(1),
    padding: theme.spacing(1.5, 2),
    marginBottom: theme.spacing(1.5),
    borderRadius: 8,
    border: '1px solid #B8956B',
    backgroundColor: '#FBF6ED',
  },
  slugWarningIcon: {
    fontSize: 20,
    color: '#8B6914',
    marginTop: 2,
    flexShrink: 0,
  },
  slugWarningText: {
    fontFamily: 'Poppins, sans-serif',
    fontSize: 13,
    lineHeight: 1.5,
    color: '#6B4E1F',
  },
  slugWarningBold: {
    fontWeight: 700,
  },
  saveButtonDisabled: {
    marginTop: theme.spacing(1),
    borderRadius: 8,
    fontFamily: 'Poppins, sans-serif',
    fontSize: 15,
    fontWeight: 600,
    textTransform: 'none',
    color: '#9B9BB0 !important',
    background: '#E8E8EE',
    boxShadow: 'none',
    padding: theme.spacing(1.2, 0),
  },
  saveButtonActive: {
    marginTop: theme.spacing(1),
    borderRadius: 8,
    fontFamily: 'Poppins, sans-serif',
    fontSize: 15,
    fontWeight: 600,
    textTransform: 'none',
    color: '#fff',
    background: '#000A8C',
    boxShadow: 'none',
    padding: theme.spacing(1.2, 0),
    '&:hover': {
      background: '#000873',
      boxShadow: 'none',
    },
  },
  closeButtonGrey: {
    marginTop: theme.spacing(1),
    borderRadius: 8,
    fontFamily: 'Poppins, sans-serif',
    fontSize: 15,
    fontWeight: 600,
    textTransform: 'none',
    color: '#6B6B80',
    background: 'transparent',
    border: '1px solid #CDCEDA',
    boxShadow: 'none',
    padding: theme.spacing(1.2, 0),
    '&:hover': {
      background: '#F7F7FB',
      borderColor: '#9B9BB0',
      boxShadow: 'none',
    },
  },

  toastWrapper: {
    position: 'absolute',
    top: -30,
    left: '50%',
    transform: 'translateX(-50%)',
    zIndex: 1,
  },
  toastContent: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    background: '#2E7D32',
    color: '#fff',
    borderRadius: 8,
    padding: theme.spacing(0.8, 1.2, 0.8, 2),
    boxShadow: '0 2px 8px rgba(0,0,0,0.25)',
    whiteSpace: 'nowrap',
  },
  toastIcon: {
    fontSize: 20,
    color: '#fff',
  },
  toastText: {
    fontFamily: 'Poppins, sans-serif',
    fontSize: 14,
    fontWeight: 600,
    color: '#fff',
    marginRight: 10,
  },
  toastClose: {
    color: '#fff',
    padding: 4,
    marginLeft: theme.spacing(0.5),
  },
}));

export default useStyles;
